import { FrameProps } from "../presentation/Frame/FrameWithMotion"
import { MotionStyle } from "framer-motion"

export function extractStyleFromProps(
    props: Partial<FrameProps>,
    name: keyof FrameProps,
    styleRef: MotionStyle,
    into?: keyof MotionStyle
) {
    if (into === undefined) {
        into = name as keyof MotionStyle
    }
    if (props[name] !== undefined) {
        styleRef[into] = props[name] as MotionStyle[typeof into]
        return
    }
}
